import { TmBaseComponent } from '@treasury/presentation';
import { circleCloseIcon, editIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-context-menu';
import '@treasury/presentation/components/tm-icon';
import '@treasury/presentation/components/tm-text-field';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'rename-accounts-group-menu';

@customElement(tagName)
export class RenameAccountsGroupMenu extends TmBaseComponent {
    @property({ type: String })
    public groupName = '';

    protected render() {
        return html`<tm-context-menu
            .openOn=${'click'}
            .closeOn=${'renameGroup'}
            .overlayClass=${'overrideDefault'}
            .items=${[{ component: this.renameMenu() }]}
        >
            <tm-button importance="primary"
                ><div class="flex items-center justify-center">
                    <tm-icon .icon=${editIcon} color="#FFF"></tm-icon> &nbsp;
                    <span>Rename Group</span>
                </div></tm-button
            ></tm-context-menu
        >`;
    }

    private dispatchRenameGroupEvent(el: HTMLElement) {
        el.dispatchEvent(
            new CustomEvent('renameGroup', {
                detail: this.groupName,
                bubbles: true,
                composed: true,
            })
        );
    }

    private renameMenu() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('px-4', 'py-4');
        wrapper.appendChild(this.renameAccountGroupHeader());
        wrapper.appendChild(this.renameAccountGroupNameInput());
        wrapper.appendChild(this.renameAccountGroupFooter());
        return wrapper;
    }

    private renameAccountGroupHeader() {
        const header = document.createElement('div');
        const titleEl = document.createElement('span');
        const closeEl = document.createElement('tm-icon');
        closeEl.icon = circleCloseIcon;
        closeEl.color = '#70757A';
        closeEl.addEventListener('click', () => {
            this.groupName = '';
            this.dispatchRenameGroupEvent(closeEl);
        });
        titleEl.innerHTML = 'Rename account group';
        header.classList.add(
            'text-secondary',
            'text-lg',
            'pb-3',
            'flex',
            'items-center',
            'justify-between'
        );
        header.appendChild(titleEl);
        header.appendChild(closeEl);
        return header;
    }

    private renameAccountGroupNameInput() {
        const input = document.createElement('tm-text-field');
        input.label = 'Group name';
        input.initial = this.groupName;
        input.addEventListener('value-changed', e => {
            this.groupName = (e.target as HTMLInputElement).value;
        });
        return input;
    }

    private renameAccountGroupFooter() {
        const footer = document.createElement('div');
        footer.classList.add('flex', 'justify-center', 'py-3');
        const button = document.createElement('tm-button');
        button.importance = 'primary';
        button.innerHTML = 'Rename group';
        button.addEventListener('click', () => {
            this.dispatchRenameGroupEvent(button);
            this.dispatchRenameGroupEvent(this);
        });
        footer.appendChild(button);
        return footer;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: RenameAccountsGroupMenu;
    }
}
